import { handleActions } from 'redux-actions'
import { setItem, deleteItem } from '../utils/localStorage'

export const user = handleActions({
  USER_LOGGED_OUT: (state, action) => {
    deleteItem('wideeyes-token')
    return {}
  },

  USER_LOGGED_IN_REQUESTED: (state, action) => state,

  USER_LOGGED_IN_COMPLETED: (state, action) => {
    //TODO change hardcoded. Set in session if user can open href links of products
    if(action.payload.config){
      setItem('wideeyes-canOpenProductLink', action.payload.config.canOpenProductLink)
    }
    setItem('annotatorId', action.payload._id)
    setItem('wideeyes-token', action.payload.token)
    return action.payload // action.payload = user
  },

  USER_LOGGED_IN_FAILED: (state, action) => {
    deleteItem('wideeyes-token')
    return {}
  },

  GET_USER_REQUESTED: (state, action) => state,

  GET_USER_COMPLETED: (state, action) => {
    setItem('wideeyes-token', action.payload.token)
    return action.payload // action.payload = user
  },

  GET_USER_FAILED: () => {
    deleteItem('wideeyes-token')
    return {}
  }
}, {})



// WEBPACK FOOTER //
// ./src/reducers/user.js